<section id="catholic-values-investing">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h1>Catholic Values Investing</h1>
      </div>
    </div>
  </div>
</section>

<section class="section">
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        @if (exclusions) {
          <div [innerHtml]="exclusions[0].html | safe: 'html'"></div>
        }
      </div>

    </div>
    <hr class="mt-5 mb-5">
    <div class="row">
      <div class="col-sm-12">
        <p>Investing for Catholics' socially responsible investing philosophy is firmly entrenched in a passive rebalancing investing strategy that maintains an ongoing screening process. The fund universe seeks to meet the following criteria:</p>
        <ul>
          <li>Passively managed, with an SRI monitoring process</li>
          <li>Style pure</li>
          <li>Conforms to the criteria for risk-appropriate tilts to specific markets as set forth by leading financial economists</li>
        </ul>
      </div>
    </div>
  </div>
</section>